import { lazy } from 'react'

// ** Document title
const TemplateTitle = '%s - Rewards Dashboard'

// ** Default Route
const DefaultRoute = '/eth-fan-v2'

// ** Merge Routes
const Routes = [
  {
    path: '/eth-fan-efbp',
    component: lazy(() => import('../../views/Home'))
  },
  {
    path: '/eth-fan-v2',
    component: lazy(() => import('../../views/RewardsV2'))
  },
  {
    path: '/eth-fan-burn',
    component: lazy(() => import('../../views/EthBurn'))
  },
  {
    path: '/buy-eft-tokens',
    component: lazy(() => import('../../views/BuyEftTokens'))
  },
  {
    path: '/votes',
    component: lazy(() => import('../../views/Votes'))
  },
  {
    path: '/vote-detail/:id',
    component: lazy(() => import('../../views/VotesDetail'))
  },
  // {
  //   path: '/rewards-calculator-v1',
  //   component: lazy(() => import('../../views/RewardsCalculator'))
  // },
  {
    path: '/eth-fan-calculator-v2',
    component: lazy(() => import('../../views/RewardsCalculatorv2'))
  },
  {
    path: '/calculator',
    component: lazy(() => import('../../views/Login')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/error',
    component: lazy(() => import('../../views/Error')),
    layout: 'BlankLayout'
  }
]

export { DefaultRoute, TemplateTitle, Routes }
